import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import { StructuredPresenterInterface } from '../structuredSelectPresenter/types'
import structuredSelectPresenter from '../structuredSelectPresenter'
import selectSeatingOrder from '../selectSeatingOrder'
import { isPresenter,isDialIn, getPureUsername } from '../../../lib/username/username'

/** Returns an array of BTIDs that we have entries in the Room object for */
const getValidBTIDs = (state: State) => {

  if (!state.room.room) return []

  return Array.from(state.room.room.participants.values()).concat([state.room.room.localParticipant as any])
    .filter(({identity}) => isPresenter(identity) || isDialIn(identity))
    .map(({identity}) => getPureUsername(identity)) 

}

/** Orders the participants in the seating order and then returns the users' data in that order */
const getParticipantInformationFromBTID = (state: State): StructuredPresenterInterface[] => {

  return selectSeatingOrder(state)
    .map(BTID => structuredSelectPresenter(state, { BTID }))

}

export default createSelector<State, any, StructuredPresenterInterface[]>(
  [getParticipantInformationFromBTID, getValidBTIDs],
  (
    participantInformationOrdered: StructuredPresenterInterface[],
    validBTIDs: string[]
  ) => {

    return participantInformationOrdered.filter(({ BTID }) => validBTIDs.includes(BTID))

  })